import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Tire from './tire';
import TireUpdate from './tire-update';
import TireDeleteDialog from './tire-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={TireUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={TireUpdate} />
      <ErrorBoundaryRoute path={match.url} component={Tire} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={TireDeleteDialog} />
  </>
);

export default Routes;
